import { HttpClient } from '@adapters/HttpClient';
import {
  CreateEndpointPayload,
  UpdateEndpointPayload,
  WebhookDeliveriesResponse,
  WebhookEndpoint,
  WebhookEndpointsResponse,
  WebhookEventTypesResponse,
} from '../models/Webhooks';

export class WebhooksApiAdapter {
  constructor(private httpClient: HttpClient) {}

  async getEndpointById(id: number): Promise<WebhookEndpoint> {
    return this.httpClient.get<WebhookEndpoint>(`/webhooks/endpoints/${id}`);
  }

  async getEndpoints(): Promise<WebhookEndpointsResponse> {
    return this.httpClient.get<WebhookEndpointsResponse>('/webhooks/endpoints');
  }

  async createEndpoint(payload: CreateEndpointPayload): Promise<WebhookEndpoint> {
    return this.httpClient.post<WebhookEndpoint>('/webhooks/endpoints', payload);
  }

  async updateEndpoint(id: number, payload: UpdateEndpointPayload): Promise<WebhookEndpoint> {
    return this.httpClient.patch<WebhookEndpoint>(`/webhooks/endpoints/${id}`, payload);
  }

  async deleteEndpoint(id: number): Promise<void> {
    return this.httpClient.delete<void>(`/webhooks/endpoints/${id}`);
  }

  async rotateSecret(id: number): Promise<WebhookEndpoint> {
    return this.httpClient.post<WebhookEndpoint>(`/webhooks/endpoints/${id}/rotate-secret`, {});
  }

  async testEndpoint(id: number): Promise<void> {
    return this.httpClient.post<void>(`/webhooks/endpoints/${id}/test`, {});
  }

  async getDeliveries(endpointId: number): Promise<WebhookDeliveriesResponse> {
    return this.httpClient.get<WebhookDeliveriesResponse>('/webhooks/deliveries', {
      endpoint_id: endpointId,
    });
  }

  async retryDelivery(deliveryId: number): Promise<void> {
    return this.httpClient.post<void>(`/webhooks/deliveries/${deliveryId}/retry`, {});
  }

  async getEventTypes(): Promise<WebhookEventTypesResponse> {
    return this.httpClient.get<WebhookEventTypesResponse>('/webhooks/event-types');
  }
}
